
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-troubleshoot',
  imports: [],
  templateUrl: './troubleshoot.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './troubleshoot.component.scss'
})
export class TroubleshootComponent {

	constructor(public activeModal: NgbActiveModal) {

	}

	close() {
		this.activeModal.dismiss();
	}
}
